var React = require('react');

function LineSecondMobile (props) {
    return React.createElement("svg",props,React.createElement("g",{"strokeLinecap":"round","strokeWidth":"2","stroke":"#DAE0E5","fill":"none"},React.createElement("path",{"d":"M126 97.62V243M254 .502v131.115h-96V255M0 18.037v113.58h96V235"})));
}

LineSecondMobile.defaultProps = {"width":"256","height":"277"};

module.exports = LineSecondMobile;

LineSecondMobile.default = LineSecondMobile;
